import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./cp-building-summary-directive.html';
import styles from './BuildingSummary-hashed.scss';
import PropertyCodeUtil from 'edge/quoteandbind/common/util/PropertyCodeUtil';

export default [function () {
    return {
        restrict: 'E',
        replace: true,
        require: 'gwCpPremisesSummary',
        scope: {
            building: '=',
            edit: '&?'
        },
        transclude: true,
        template: cssUtil.hashTemplate(template, styles),
        controller: ['$scope', '$state', 'InsuranceSuiteMetadata', function ($scope, $state, insuranceSuiteMetadata) {

            var typelist = insuranceSuiteMetadata.get('pc').types.getTypelist('Sprinklered');
            $scope.sprinklered = $scope.building.percentageSprinklered ? typelist.getCode($scope.building.percentageSprinklered).name : null;
            $scope.formatClassCode = PropertyCodeUtil.toString;

            if (!$scope.edit) {
                $scope.edit = function () {
                    $state.go('cpBuildingWizardEditBuilding', { building: $scope.building });
                };
            }
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/directives/cp-premises-summary-directive/cp-building-summary-directive/CPBuildingSummaryDirective.js
// module id = 998
// module chunks = 0